import React, { useEffect, useState } from 'react';
import { fetchJson } from '../../apiBase';
import { Card } from '../components/ui';
import { CETELE_ICONS } from '../../shared/ceteleTemplates';

const KIND_ICON = {
  ...CETELE_ICONS,
  custom: '📚',
};
const STATUS = {
  pass: { symbol: '✓', title: 'Öğrendi', background: '#e7f9ee', ink: '#087845' },
  retry: { symbol: '↻', title: 'Tekrar gerekli', background: '#fff3e8', ink: '#b65b15' },
};

function ChecklistCard({ checklist }) {
  const controls = [...(checklist.controls || [])].sort((a, b) => a.position - b.position);
  const latest = [...controls].reverse().find(control => control.status === 'pass' || control.status === 'retry');
  const passed = controls.filter(c => c.status === 'pass').length;
  const retry = controls.filter(c => c.status === 'retry').length;
  const current = STATUS[latest?.status];
  const icon = KIND_ICON[checklist.template_key] || KIND_ICON.custom;

  return <section style={{ border: '1px solid #dbe6f6', borderRadius: 16,
    padding: 14, minWidth: 0, background: '#fff', display: 'grid', gap: 14 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10,
      background: 'linear-gradient(110deg,#f2efff,#e5f2ff,#fff4e6)',
      borderRadius: 14, padding: '14px 12px', alignItems: 'center' }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 19, color: '#16254d', fontWeight: 900, lineHeight: 1.35 }}>
          {icon} {checklist.title}
        </div>
        <div style={{ color: '#465570', marginTop: 4, fontSize: 13, fontWeight: 650 }}>
          {checklist.subject} · {checklist.class_code} · {controls.length} değerlendirme
        </div>
      </div>
      <span aria-hidden="true" style={{ fontSize: 38, flexShrink: 0 }}>🐼</span>
    </div>
    <div style={{ background: current ? current.background : '#f5f7fa',
      border: '1px solid ' + (current ? (latest.status === 'pass' ? '#c9ecd9' : '#f8dcc5') : '#e4e8ef'),
      borderRadius: 14, padding: 14, display: 'flex', alignItems: 'flex-start', gap: 12 }}>
      <div aria-hidden="true" style={{
        width: 42, height: 42, flex: '0 0 42px', display: 'grid', placeItems: 'center',
        borderRadius: '50%', background: current ? (latest.status === 'pass' ? '#29ab76' : '#e98b3b') : '#8998aa',
        color: '#fff', fontSize: 22, fontWeight: 900,
      }}>{current?.symbol || '—'}</div>
      <div style={{ minWidth: 0 }}>
        <div style={{ color: '#45556d', fontSize: 12, fontWeight: 700 }}>
          {latest ? latest.title : 'Henüz değerlendirme yok'}
        </div>
        <div style={{ color: current?.ink || '#465570',
          fontWeight: 900, fontSize: 18, marginTop: 3 }}>
          {latest?.status === 'pass' ? 'Öğrendi ✨' :
            latest?.status === 'retry' ? 'Biraz daha pratik! 🌱' : 'Değerlendirme bekleniyor'}
        </div>
        <div style={{ color: '#45556d', fontSize: 13, lineHeight: 1.5, marginTop: 6 }}>
          {latest?.status === 'pass'
            ? 'Bu çalışma hedefi başarıyla öğrenildi. Harika bir adım!'
            : latest?.status === 'retry'
              ? 'Bu çalışma hedefi için biraz daha tekrar öneriliyor.'
              : 'Öğretmen değerlendirme yaptığında sonuç burada görünecek.'}
        </div>
      </div>
    </div>
    <div style={{ minWidth: 0 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8,
        alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' }}>
        <strong style={{ color: '#0f1e56', fontSize: 16 }}>Değerlendirme Geçmişi</strong>
        <span style={{ color: '#52617c', fontSize: 12, fontWeight: 700 }}>
          {passed} öğrendi · {retry} tekrar
        </span>
      </div>
      {controls.length ? <div style={{ display: 'flex', gap: 7,
        overflowX: 'auto', maxWidth: '100%', paddingBottom: 5 }}>
        {controls.map(c => {
          const status = STATUS[c.status];
          const isLatest = latest?.id === c.id;
          return <div key={c.id} title={c.title + ': ' + (status?.title || 'Henüz değerlendirilmedi')}
            style={{ flex: '0 0 120px', minWidth: 0, padding: '10px 5px',
              borderRadius: 10, textAlign: 'center',
              border: isLatest ? '2px solid #936efa' : '1px solid #dce5f0',
              background: isLatest ? '#f9f6ff' : '#f8fbfe' }}>
            <div style={{ color: '#465570', fontSize: 12, fontWeight: 700,
              lineHeight: 1.4, overflowWrap: 'anywhere' }}>{c.title}</div>
            <div style={{ margin: '8px auto 0', width: 25, height: 25,
              borderRadius: '50%', display: 'grid', placeItems: 'center',
              background: status ? (c.status === 'pass' ? '#16a365' : '#ea8030') : '#e1e6ef',
              color: status ? '#fff' : '#718096', fontWeight: 900 }}>
              {status?.symbol || '—'}
            </div>
          </div>;
        })}
      </div> : <div style={{ color: '#45556d', fontSize: 13 }}>Henüz değerlendirme oluşturulmadı.</div>}
      <div style={{ color: '#52617c', fontSize: 12, marginTop: 8, lineHeight: 1.6 }}>
        🟢 Öğrendi · 🟠 Tekrar gerekli · ⚪ Henüz değerlendirilmedi
      </div>
    </div>
  </section>;
}

export default function CeteleReport({ studentId, refreshKey }) {
  const [state, setState] = useState({ loading: true, items: [], error: false });
  useEffect(() => {
    if (!studentId) {
      setState({ loading: false, items: [], error: false });
      return undefined;
    }
    let active = true;
    setState({ loading: true, items: [], error: false });
    fetchJson('/parent/ceteles?student_id=' + encodeURIComponent(studentId))
      .then(async res => { if (!res.ok) throw new Error('failed'); return res.json(); })
      .then(data => { if (active) setState({ loading: false, items: data.items || [], error: false }); })
      .catch(() => { if (active) setState({ loading: false, items: [], error: true }); });
    return () => { active = false; };
  }, [studentId, refreshKey]);

  if (state.loading) return <p style={{ color: '#45556d' }}>Çeteleler yükleniyor…</p>;
  if (state.error) return <p style={{ color: '#8f2834' }}>Çetele bilgileri şu anda alınamıyor.</p>;
  if (!state.items.length) return null;
  return <Card title="Çetelelerim">
    <div style={{ display: 'grid', gap: 12 }}>
      {state.items.map(item => <ChecklistCard key={item.id} checklist={item} />)}
    </div>
  </Card>;
}
